<template>
  <ElForm
    :model="teamMember"
    :rules="formRules"
    ref="team-member-form"
    label-position="top"
    label-width="120px"
    status-icon
    @submit.native.prevent
  >
<!--    @submit.native.prevent="onFormSubmit"-->
    <ElFormItem
      v-if="isAddForm"
      prop="email"
    >
      <template slot="label">
        Login <span class="font-normal text-sm">(Email)</span>
      </template>
      <ElInput
        ref="input-email"
        v-model="teamMember.email"
        name="email"
        placeholder="name@example.com"
        autocomplete="username"
      />
    </ElFormItem>
    <template v-if="noPasswordUpdate">
      <p class="font-medium text-primary-light">Password</p>
      <p class="text-sm text-primary-light italic mb-20">
        The password was set by the user
      </p>
    </template>
    <ElFormItem
      v-else
      label="Password"
      prop="password"
      class="pb-10"
    >
      <ElInput
        v-model="teamMember.password"
        name="password"
        autocomplete="new-password"
        placeholder="*******"
        show-password
      />
    </ElFormItem>
    <ElFormItem
      label="Name"
      prop="name"
    >
      <ElInput
        v-model="teamMember.name"
        placeholder="Member name"
        class="w-auto"
      />
    </ElFormItem>
    <ElFormItem
      label="Role"
      prop="role"
    >
      <ElSelect
        v-model="teamMember.role"
        placeholder="Select a role"
      >
        <ElOption
          v-for="option in roleOptions"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        />
      </ElSelect>
    </ElFormItem>
    <ElFormItem
      v-if="teamMember.role === 'eventPromoter'"
      label="Max. guests"
      prop="maxGuests"
    >
      <ElInputNumber
        v-model="teamMember.maxGuests"
        :min="0"
      />
    </ElFormItem>
    <slot :submitForm="onFormSubmit" />
  </ElForm>
</template>

<script>
const defaultTeamMemberFields = {
  name: '',
  email: '',
  password: '',
  role: 'guestsCheckIn', // guestsFullAccess, guestsCheckIn, eventPromoter
  maxGuests: 0,
};

export default {
  props: {
    existingTeamMember: {
      type: Object,
    },
    noPasswordUpdate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (!value || value === '') {
        callback('Please enter a member name');
      }
      callback();
    };
    const validateEmail = (rule, value, callback) => {
      const re = /^.+@.+\..+$/;

      if (!value || value.length === 0) {
        callback('Please enter your Email');
      } else if (!re.test(value) || value.length >= 256 || value.includes(' ')) {
        callback('Please enter a valid Email');
      }
      callback();
    };
    const validatePassword = (rule, value, callback) => {
      if (!value || value === '') {
        callback('Please enter a password');
      } else if (value.length < 8) {
        callback('Please enter a at least 8 characters');
      }
      callback();
    };

    return {
      formRules: {
        name: [{
          validator: validateName,
          trigger: 'blur',
        }],
        email: [{
          validator: validateEmail,
          trigger: 'blur',
        }],
        password: [{
          validator: validatePassword,
          trigger: 'blur',
        }],
      },
      roleOptions: [{ // TODO: One source for the roles options/values
        label: 'Guest check-in/out only',
        value: 'guestsCheckIn',
      }, {
        label: 'Manager',
        value: 'guestsFullAccess',
      }],
      // 'eventPromoter' is hidden from the picker for now (2026-09-13); existing promoter members keep working
      teamMember: { ...defaultTeamMemberFields },
    };
  },
  watch: {
    existingTeamMember: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.teamMember = { ...defaultTeamMemberFields };
          return;
        }

        const {
          name, email, password, role, maxGuests,
        } = value;

        this.teamMember = {
          name: name || defaultTeamMemberFields.name,
          email: email || defaultTeamMemberFields.email,
          password: password || defaultTeamMemberFields.password,
          role: role || defaultTeamMemberFields.role,
          maxGuests: maxGuests || defaultTeamMemberFields.maxGuests,
        };
      },
    },
  },
  computed: {
    isAddForm() {
      return !this.existingTeamMember;
    },
  },
  methods: {
    async onFormSubmit() {
      const formIsValidated = await this.$refs['team-member-form']
        .validate()
        .then((v) => v)
        .catch((v) => v);
      if (!formIsValidated) return;

      const { maxGuests, password, ...restOfFields } = this.teamMember;
      const teamMember = {
        ...restOfFields,
        ...(this.teamMember.role === 'eventPromoter' && { maxGuests }), // Add maxGuests if member is eventPromoter
        ...(password && { password }), // Add password if not empty
      };

      this.$emit('submit', teamMember);
    },
    focusFirstInputField() {
      if (this.existingMemberDetails || !this.$refs['input-email']) return;
      this.$nextTick(() => {
        this.$refs['input-email'].focus();
      });
      // this.$refs['input-email'].focus();
      // console.log(this.$refs['input-email']);
    },
    resetForm() {
      this.$refs['team-member-form'].resetFields();
      this.$refs['team-member-form'].clearValidate();
    },
  },
};
</script>

<style scoped>

</style>
